import { useState } from "react";
import axios from 'axios';
export interface IsState {
    response?: any,
    loading: Boolean,
    error?: String
}

export interface contactData {
    contact: {
        email?: string,
        optInType?: string,
        emailType: string,
        dataFields?: [
            {
                key: string
                value: string | number | boolean | Date
            }
        ]
    }
}

export const useCreateContact = () => {
    const [state, setState] = useState<IsState | null>({
        response: null,
        loading: false,
        error: null
    })
    const createContact = async (data: contactData) => {
        // setState({ response: null, loading: true, error: null })
        try {
            const output = await fetch('/.netlify/functions/dot-digital-create-contact', {
                method: 'POST',
                body: JSON.stringify(data)
            })
            const res = await output.json()
            setState({ response: res, loading: false, error: null })
        } catch (error) {
            setState({
                response: null,
                loading: false,
                error: error
            })
        }
    }

    return [createContact, state]
}